var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 7.9998V5.9998C13.015 5.33908 12.896 4.68216 12.65 4.06874C12.4041 3.45531 12.0363 2.89811 11.569 2.43078C11.1017 1.96346 10.5445 1.59572 9.93107 1.34977C9.31764 1.10382 8.66072 0.984763 8 0.999801C6.69942 0.975692 5.44243 1.46866 4.50499 2.37048C3.56754 3.2723 3.02627 4.50927 3 5.8098V7.9998H0V18.9998C0 19.5302 0.210714 20.0389 0.585786 20.414C0.960859 20.7891 1.46957 20.9998 2 20.9998H14C14.5304 20.9998 15.0391 20.7891 15.4142 20.414C15.7893 20.0389 16 19.5302 16 18.9998V7.9998H13ZM5 5.8098C5.0261 5.03966 5.3566 4.31131 5.919 3.78452C6.48141 3.25773 7.2298 2.97553 8 2.9998C8.39811 2.98434 8.79512 3.05135 9.1661 3.19665C9.53707 3.34194 9.874 3.56237 10.1557 3.84408C10.4374 4.1258 10.6579 4.46273 10.8032 4.83371C10.9484 5.20468 11.0155 5.60169 11 5.9998V7.9998H5V5.8098ZM14 18.9998H2V9.9998H14V18.9998Z",
    fill: "#38e5e2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.89681dfe18287749b9ba2f4b18070981.svg";
export { ForwardRef as ReactComponent };